/**
 * Programmatic blob download (Chromium / Arc / Edge–safe).
 * A detached <a> with a blob: URL plus immediate revokeObjectURL often fails there;
 * Safari is more forgiving.
 */

const REVOKE_OBJECT_URL_MS = 400;

export function triggerBlobFileDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  a.style.display = 'none';
  a.setAttribute('download', filename);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.setTimeout(() => {
    if (typeof URL.revokeObjectURL === 'function') URL.revokeObjectURL(url);
  }, REVOKE_OBJECT_URL_MS);
}
